"use client";

import Breadcrumbs from "@/components/breadCrumbAndButton/BreadCrumbAndButton";
import Sidebar from "@/components/sideBar/SideBar";
import "../about-us/style.css";
import CommonBanner from "@/components/commonBanner/CommonBanner";
export default function TermsAndConditionsClient() {
  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Home", href: "/" },
          // { label: "Terms and Conditions & Disclaimer" },
          { label: "Terms of Services" },
        ]}
      />

      {/* ================= POST HEADER ================= */}
      <div className="post-head container">
        <div className="post-head-wrapper">
          <picture>
            <source
              type="image/webp"
              sizes="(max-width: 1680px) 95vw, (min-width: 1681px) 1600px"
              srcSet="
                  https://cdn.coinccinos.com/content/images/size/w3000/format/webp/2024/03/terms-and-conditions.webp 3000w,
                  https://cdn.coinccinos.com/content/images/size/w2400/format/webp/2024/03/terms-and-conditions.webp 2400w,
                  https://cdn.coinccinos.com/content/images/size/w2000/format/webp/2024/03/terms-and-conditions.webp 2000w,
                  https://cdn.coinccinos.com/content/images/size/w1600/format/webp/2024/03/terms-and-conditions.webp 1600w,
                  https://cdn.coinccinos.com/content/images/size/w1000/format/webp/2024/03/terms-and-conditions.webp 1000w,
                  https://cdn.coinccinos.com/content/images/size/w800/format/webp/2024/03/terms-and-conditions.webp 800w,
                  https://cdn.coinccinos.com/content/images/size/w500/format/webp/2024/03/terms-and-conditions.webp 500w
                "
            />
            <img
              className="post-feature-image"
              alt="Terms and Conditions | coinccino"
              src="https://cdn.coinccinos.com/content/images/size/w3000/2024/03/terms-and-conditions.webp"
            />
          </picture>

          <CommonBanner
            authorSlug="riccardocuratolo"
            authorImageSrcSetWebp="https://cdn.coinccinos.com/content/images/size/w200/format/webp/2024/12/Riccardo-Curatolo.webp 200w, https://cdn.coinccinos.com/content/images/size/w100/format/webp/2024/12/Riccardo-Curatolo.webp 100w"
            authorImageSrcSet="https://cdn.coinccinos.com/content/images/size/w200/2024/12/Riccardo-Curatolo.webp 200w, https://cdn.coinccinos.com/content/images/size/w100/2024/12/Riccardo-Curatolo.webp 100w"
            authorImage="https://cdn.coinccinos.com/content/images/size/w200/2024/12/Riccardo-Curatolo.webp"
            authorName="Riccardo Curatolo"
            dateISO="2022-12-10"
            dateLabel="Dec 10, 2022"
            readTime="1 min read"
            title="Terms and Conditions & Disclaimer"
            excerpt="These Terms govern the use of this Website and any other agreement or legal relationship with the Owner in a binding manner."
          // shareUrl=""
          />
        </div>
      </div>

      <div className="container post-main-wrapper with-sidebar">
        <div className="row gap-2">
          {/* Main Content Column */}
          <div className="col-lg-8 col-md-7 post-page-main">
            <div className="post-content with-sidebar">
              <h2 id="terms-of-services">Terms of Services</h2>

              <p>
                Coinccino ensures that all information contained on pages hosted
                on https://coinccinos.com or Coinccino’s subdomains is correct
                and up to date. We cannot, however, accept responsibility for
                the content of external websites linked to through
                https://coinccinos.com. Third party content is accessed at the
                user’s own risk. Coinccino cannot accept responsibility for any
                loss or inconvenience caused by reliance on any material
                contained in this site.
              </p>

              <p>
                Please note that despite the nature of much of the material
                created and hosted on this website, Coinccino is not a financial
                reference resource and the opinions of authors and other
                contributors are their own and should not be taken as financial
                advice. If you require advice of this sort, Coinccino strongly
                recommends contacting a qualified industry professional. All
                materials on this site are for informational purposes only. None
                of the material should be interpreted as investment advice.
              </p>

              <p>
                By accessing coinccinos.com, you agree and consent to the
                policies contained in the above Terms of Service Agreement.
              </p>

              <p>
                Specifically, you agree to hold Coinccino, its affiliates,
                officers, directors, employees, agents, and third party service
                providers harmless from and defend them against any claims,
                costs, damages, losses, expenses, and any other liabilities,
                including attorneys’ fees and costs, arising out of or related
                to your access to or use of Coinccino, your violation of this
                user agreement, and/or your violation of the rights of any third
                party or person.
              </p>

              <p>
                We will not be liable for any special, consequential, indirect,
                incidental, punitive, reliance, or exemplary damages, whether in
                tort, contract, or any other legal theory, arising out of or in
                any way connected with this agreement or your use of or attempt
                to use Coinccino.
              </p>

              <p>
                You agree to release us, our affiliates, and third-party service
                providers, and each associated director, employee, agents, and
                officers, from claims, demands and damages of every kind and
                nature, arising out of or in any way connected to your use of
                Coinccino.
              </p>

              {/* <div className="d-flex">
                  <Faqs />
                </div> */}
            </div>
          </div>

          {/* Sidebar Column */}
          <div className="col-lg-6 col-md-5">
            <Sidebar />
          </div>
        </div>
      </div>
    </div>
  );
}
